// extracted by mini-css-extract-plugin
var _1 = "NB9A0";
export { _1 as "base" }
